// extracted by mini-css-extract-plugin
module.exports = {"section":"SectionRelated_section__jxdID","btnWrap":"SectionRelated_btnWrap__rUPm7","btn":"SectionRelated_btn__sa9_8"};